// 平台接口文档 https://op.jinritemai.com/docs/api-docs/14/1614
import genkey from '@/utils/genkey.js'
import { cloneDeep } from 'lodash';
import { fxgGetParallelCascadeValues } from '@/api/prod/center';
const defaultRules = {
    name: '规格A',
    nameKey: 'n_key',
    values: [ // 规格明细
    ]
}
/**
 * 获取无法匹配到的规格列表
 * @param {*} productSpecRule 平台规格信息
 * @param {*} defaultSpecifications 详情里的规格信息
 * @returns 
 */
const getUnmatchedSpecifications = (productSpecRule, defaultSpecifications) => {
    const platformSpecifications = cloneDeep(productSpecRule);
    defaultSpecifications.forEach(item => {
        const matchIndex = platformSpecifications.findIndex(spec => {
            return spec && (spec.sellPropertyName.includes(item.name) || item.name.includes(spec.sellPropertyName));
        });
        if (matchIndex > -1) {
            platformSpecifications.splice(matchIndex, 1, null)
        }
    });
    return platformSpecifications.filter(item => !!item);
}
/**
 * /**
 * 生成抖店规格明细
 * @param {*} productSpecRule 规则
 * @param {*} defaultSpecifications 默认的规格列表
 * @param {*} fxgProductUpdateRuleParams cascader类型时需要额外请求接口替换options值，该参数为请求接口的参数
 * @returns 
 */
export const gernerateFxgSpecs = async (productSpecRule, defaultSpecifications = [], fxgProductUpdateRuleParams) => {
    // const { maxSpecNumLimit, supportPropertyDiy } = productSpecRule;
    const requiredSpecDetails = cloneDeep(productSpecRule.requiredSpecDetails || [])
    const originRequiredSpecDetails = cloneDeep(requiredSpecDetails)
    const needlessSpecList = [];
    const newRequiredSpecDetails = [];
    // 先生成无法匹配的规格列表
    let unmatchedSpecifications = getUnmatchedSpecifications(requiredSpecDetails, defaultSpecifications);
    // 需求背景：抖音SKU改造需要动态处理规格信息，抖音平台所需规格信息可能会与我们平台不一致
    // 生成规格明细列表，需要完全依赖怒基础资料中的规格信息（主要是各个规格数量需要保持一致）
    // 采用下标顺序index:index将快麦通detail接口中的specifications与平台requiredSpecDetails 中的规格进行匹配
    for (let specIndex = 0; specIndex < defaultSpecifications.length; specIndex++) {
        const defaultItem = defaultSpecifications[specIndex];
        let requiredSpecItem = originRequiredSpecDetails[specIndex];
        if (!requiredSpecItem) {
            // 平台规格信息为空表示 基础资料规格数量比平台规格数量多
            // 拷贝基础资料中的规格信息，以自定义输入框的形式填充至页面
            const customSpec = getCustomSpecItem(defaultItem)
            newRequiredSpecDetails.push(customSpec);
            needlessSpecList.push(customSpec);
        } else {
            let findIndex = -1
            //1、先根据name模糊必填匹配
            findIndex = requiredSpecDetails.findIndex(sp => {
                const name = sp.sellPropertyName
                return (name.includes(defaultItem.name) || defaultItem.name.includes(name)) && sp.isRequired; // 根据name 模糊匹配
            });
            // 2、name精确匹配
            if(findIndex === -1) {
                findIndex = requiredSpecDetails.findIndex(item => item.sellPropertyName === defaultItem.name);
            }
            // 3、name模糊匹配
            if(findIndex === -1) {
                findIndex = requiredSpecDetails.findIndex(sp => {
                    const name = sp.sellPropertyName
                    return name.includes(defaultItem.name) || defaultItem.name.includes(name); // 根据name 模糊匹配
                });
            }
            // 4、不匹配的情况，则从无法匹配的规格列表里按顺序获取
            if (findIndex === -1) {
                const firstUnmatchedItem = unmatchedSpecifications[0];
                if(!firstUnmatchedItem) {
                    const customSpec = getCustomSpecItem(defaultItem)
                    newRequiredSpecDetails.push(customSpec);
                    needlessSpecList.push(customSpec);
                    continue;
                } else {
                    findIndex = requiredSpecDetails.findIndex(item => item.sellPropertyName === firstUnmatchedItem.sellPropertyName)
                    unmatchedSpecifications.splice(0, 1);
                }
            }
            requiredSpecItem = requiredSpecDetails[findIndex];
            requiredSpecDetails.splice(findIndex, 1)
            const requiredSpec = await gernerateSpecItem(requiredSpecItem, defaultItem, fxgProductUpdateRuleParams)
            newRequiredSpecDetails.push(requiredSpec)
        }
    }

    requiredSpecDetails.filter(item => item.isRequired).forEach(async (item, index) => {
        if(item.isRequired) {
            const requiredSpec = await gernerateSpecItem(item, {}, fxgProductUpdateRuleParams)
            newRequiredSpecDetails.push(requiredSpec)
            requiredSpecDetails.splice(index, 1)
        }
    })
    return {
        newSpec: newRequiredSpecDetails,
        unrenderList: requiredSpecDetails,
        needlessSpecList
    };
}
const getCustomSpecItem = (defaultItem) => {
    const matchItem = cloneDeep(defaultItem);
    const { values = [] } = matchItem;
    matchItem.values = formatSpecValues(values, {
        sellPropertyId: 0,
        sellPropertyName: matchItem.name,
        propertyValues: [],
        measureTemplates: [],
    });
    const customSpec = {
        id: 0,
        name: matchItem.name,
        nameKey: matchItem.nameKey,
        ...matchItem,
        valueItemRule: {},
        // editPropertyName: false,
    }
    return customSpec
}
export const gernerateSpecItem = async (requiredSpecItem, defaultItem = {}, fxgProductUpdateRuleParams = {}) => {
    // 平台规格和基础资料里的规格能逐一匹配到
    const {
        sellPropertyId, // 规格ID
        sellPropertyName, // 规格名称
        supportRemark, // 是否需要备注
        supportDiy, // 是否支持自定义
        valueDisplayStyle, // 默认显示
        needPagingQueryValue, // 是否需要二次查询规格值
        propertyValues = [], // 规格值选项
        navigationProperties = [], // 导航栏
        isRequired,
        measureTemplates = []
    } = requiredSpecItem;
    // 导航样式的数据需要特殊处理，需要重新请求接口获取规格值数据并替换掉接口返回的原propertyValues值
    let newPropertyValues = propertyValues;
    if (['cascader', 'cascader_multi_select'].includes(valueDisplayStyle)) {
        const { propertyId, propertyName } = navigationProperties[0];
        const response = await fxgGetParallelCascadeValues({
            ...fxgProductUpdateRuleParams,
            sellPropertyId,
            sellPropertyName,
            navigationPropertyId: propertyId,
            navigationPropertyName: propertyName,
        });
        const { data = [] } = response;
        newPropertyValues = (data || []).map(item => {
            const { propertyValueName, propertyValueId } = item;
            item['sellPropertyValueName'] = propertyValueName;
            item['sellPropertyValueId'] = propertyValueId;
            return item;
        });
    }
    // 规格项渲染所需要的平台参数
    const valueItemRule = {
        sellPropertyId,
        supportRemark,
        supportDiy,
        valueDisplayStyle,
        needPagingQueryValue,
        propertyValues: newPropertyValues,
        sellPropertyName,
        isRequired,
        navigationProperties,
        measureTemplates,
    };
    // 去和detail接口中的specifications进行匹配，如果有匹配到，则进行相应的赋值
    let hasMatch = defaultItem.name === sellPropertyName ? true : false;
    const matchedData = cloneDeep(defaultItem);
    const { values = [] } = matchedData;
    // 规格值项处理
    matchedData.values = formatSpecValues(values, requiredSpecItem);
    const requiredSpec = {
        ...matchedData,
        id: sellPropertyId,
        name: sellPropertyName,
        valueItemRule
    };
    // 逐一匹配规格名字，从基础资料同步过来的数据，未经保存过可能会存在不匹配
    // 在系统二次保存后，也是在这里进行正常匹配。
    // 未匹配的数据需要特殊处理一下
    if (!hasMatch) {
        Object.assign(requiredSpec, {
            name: sellPropertyName,
            nameKey: sellPropertyName,
            note: matchedData.note,
            valueKey: matchedData.valueKey || sellPropertyName,
        })
    }
    return requiredSpec;
}
/**
 * 处理规格值数据
 * @param {*} values 规格值
 * @param {*} specItem
 * @returns 
 */
export const formatSpecValues = (values = [], specItem) => {
    const { propertyValues=[], measureTemplates = [] } = cloneDeep(specItem);
    if(!values?.length) {
        values = [gernerateDefaultSpecValueItem(specItem)]
    }
    const newValues = values.map(valueItem => {
        const matchProperty = propertyValues.find(property => property.sellPropertyValueName === valueItem.value);
        const formatValueItem = {
            ...gernerateDefaultSpecValueItem(specItem),
            valueKey: valueItem.valueKey,
            // checked: valueItem.checked,
            imageUrl: valueItem.imageUrl === '/resources/css/build/images/no_pic.png' ? '' : valueItem.imageUrl,
        }
        // 度量衡特殊数据处理
        if (measureTemplates.length > 0) {
            let measureTemplate = measureTemplates[0];
            const { templateId } = valueItem?.fxgExtra?.measureInfo || {};
            // 这里需要判断数据是否为同一度量衡模板
            // 主要是为了兼容随意切换类目的数据能够最大程度上平移过来
            // 也为了保存之后的二次回显
            const matchTemplate = measureTemplates.find(item => {
                return item.templateId === templateId;
            });
            if (templateId && matchTemplate) {
                measureTemplate = matchTemplate;
                const { valueModules } = measureTemplate;
                let { values } = valueItem.fxgExtra.measureInfo;
                const measureValues = valueModules.map((item, index) => {
                    return Object.assign(item, {
                        ...values[index]
                    });
                });
                Object.assign(formatValueItem.fxgExtra, {
                    measureInfo: {
                        templateId,
                        values: cloneDeep(measureValues)
                    }
                })
                Object.assign(formatValueItem, {
                    value: fomatMeasureInfoItemValue(measureValues),
                    note: valueItem.note
                })
            } else {
                const { valueModules } = measureTemplate;
                // 未匹配到，表示是由非度量衡类目切换到含有度量衡的类目
                // 或者说数据无法兼容的情况
                const measureValues = valueModules.map(item => {
                    item.value = '';
                    item.unitId = '';
                    return item;
                });
                Object.assign(formatValueItem.fxgExtra, {
                    measureInfo: {
                        templateId: measureTemplate.templateId,
                        values: cloneDeep(measureValues)
                    }
                });
                Object.assign(formatValueItem, {
                    note: (valueItem.note || '') + valueItem.value
                })
            }
        } else if (matchProperty) {
            // select,checkbox等情况下需要去匹配当前值是否在平台返回的options中
            formatValueItem.value = matchProperty.sellPropertyValueName;
            //   + matchProperty.sellPropertyValueName;
            formatValueItem.note = (valueItem.note || '');
            if (valueItem.fxgExtra) {
                formatValueItem.fxgExtra = valueItem.fxgExtra
            }
        } else {
            // 不匹配也照样复制
            // input为纯自定义输入框，不会做校验
            // select下拉框会去判断选项值是否符合输入情况，在DdianSpecification.vue文件中做校验
            formatValueItem.value = valueItem.value;
            formatValueItem.note = valueItem.note;
        }
        return formatValueItem
    });
    return cloneDeep(newValues);
}
/**
 * 生成抖音SKU新规范的模板数据
 * @param {*} valueItemRule
 * @returns
 */
export const gernerateDefaultSpecValueItem = (valueItemRule = {}) => {
    const { sellPropertyId, sellPropertyName, } = valueItemRule;
    return {
        nameKey: sellPropertyName,
        value: '无规格',
        valueKey: genkey.get('v'),
        propId: sellPropertyId,
        imageUrl: '',
        note: '',
        checked: true,
        fxgExtra: {
            skuClassificationType: '',
            measureInfo: {
                templateId: '',
                values: []
            },
            cpvPathList: [],
            valueId: 0,
            showValue: ''
        },
    };
}
/**
 * 处理提交时的规格信息数据
 * @param {*} specifications 
 * @returns 
 */
export const formatSubmitSpecs = (specifications) => {
    const newSpecifications = specifications.map(item => {
        const { values = [], valueItemRule = {} } = item;
        const { propertyValues = [], valueDisplayStyle, navigationProperties } = valueItemRule;
        item.values = values.map(val => {
            // 输入框的情况下匹配name，找到其对应的valueId
            // 没有匹配到则说明为自定义规格值，valueId赋值0
            if (['select', 'checkbox'].includes(valueDisplayStyle)) {
                const matchProperty = propertyValues.find(pro => {
                    return pro.sellPropertyValueName === val.value;
                })
                if (matchProperty) {
                    val.fxgExtra.valueId = matchProperty.sellPropertyValueId;
                } else {
                    val.fxgExtra.valueId = 0;
                }
            } else if (['cascader', 'cascader_multi_select'].includes(valueDisplayStyle)) {
                const matchOptionItem = propertyValues.find(item => {
                    return !item._created && item.sellPropertyValueName === val.value;
                });
                const cpvPathList = [];
                if (matchOptionItem) {
                    const { navigationPropertyId, navigationPropertyValueId, propertyId, sellPropertyValueId } = matchOptionItem;
                    cpvPathList.push({
                        cpid: navigationPropertyId,
                        cpvId: navigationPropertyValueId
                    });
                    cpvPathList.push({
                        cpid: propertyId,
                        cpvId: sellPropertyValueId
                    });
                    val.fxgExtra.valueId = sellPropertyValueId;
                } else {
                    navigationProperties.forEach(item => {
                        const { propertyId } = item;
                        cpvPathList.push({
                            cpid: propertyId,
                            cpvId: 0
                        });
                    });
                    val.fxgExtra.valueId = 0;
                }
                val.fxgExtra.cpvPathList = cpvPathList;
            }
            const { fxgExtra = {} } = val;
            // 度量衡数据处理，主要是删除多余字段
            if (fxgExtra.measureInfo) {
                const { values: measureValues = [] } = fxgExtra.measureInfo || {};
                fxgExtra.measureInfo.values = measureValues.map(valItem => {
                    delete valItem['units']
                    delete valItem['validateRule']
                    return valItem;
                })
            }
            return val;
        });
        // 删除多余字段
        delete item['valueItemRule'];
        delete item['renderType'];
        delete item['renderOptions'];
        return item;
    });
    return newSpecifications;
}
export const parseProductFormat = (val) => {
    if (!val) return { initAttrData: {}, initMeasureData: {}};
    try {
        // 新版的类目属性字段是个JSON对象
        const newAttr = JSON.parse(val)
        const newFormData = {}
        const initMeasureData = {}
        for (const propId in newAttr) {
            let _value = newAttr[propId]
            const hasMeasure_info = _value.some(v => v.measure_info)  // 判读是否是 度量衡
            if(hasMeasure_info) {
                initMeasureData[propId] = _value
            } else {
                if  (_value.length > 1) {
                    _value = _value.map(v => v.value === 0 ? v.name : Number(v.value))
                } else if (_value.length) {
                    _value = _value[0]
                    _value = _value.value === 0 ? _value.name : Number(_value.value)
                } else {
                    continue
                }
                newFormData[propId] = _value
            } 
        }
        return { initMeasureData: initMeasureData, initAttrData: newFormData}
    } catch (error) {
        // 报错了就是老版本
        const attrs = val.split('^');
        const formData = {}
        attrs.forEach(attr => {
            const arr = attr.split('|');
            if (arr.length > 2) {
                formData[arr[0]] = arr.slice(1);
            } else {
                formData[arr[0]] = arr[1];
            }
        });
        return { initAttrData: formData, initMeasureData: {} };
    } 
}
/**
 * 度量衡数据处理，主要是为了前端回显拼凑各项值
 * @param {*} values 
 * @returns 
 */
export const fomatMeasureInfoItemValue = (values) => {
    const valueStrList = [];
    values.forEach(item => {
        const { prefix, suffix, value, unitId, units } = item;
        // 输入框必须有值才会去拼接数据，前置文案+值+单位+后置文案
        if (value) {
            // 前置文案
            if (prefix) {
                valueStrList.push(prefix);
            }
            // 值
            valueStrList.push(value);
            // 单位
            if (unitId) {
                const matchUnit = units.find(item => {
                    return item.unitId === unitId;
                })
                valueStrList.push(matchUnit?.unitName || '');
            }
            // 后置文案
            if (suffix) {
                valueStrList.push(suffix);
            }

        }
    })
    return valueStrList.join('')
}

import { validateSkuPrice,validateSkuPicture } from './rules.js';
export const skuTableCols = (_this)=>{
    let openSource = _this.openSource
    let isShowPreviewPrice = true;
    if(['taskCenter','previewPublish'].includes(openSource)){
        isShowPreviewPrice = false
    }
    const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
    let tableCols = [
        { prop: 'skuPicture', 
            attrs: { label: 'sku图', noRequired: false, width:'100'}, 
            input: { type: 'img',onlyTable:true, validator: (value, prop, sku) => validateSkuPicture(value, prop, _this, sku) }, 
            unvisible: !_this.skuPictureRule?.support, 
            slot: true,headerSlot:true 
        },
        // { prop: 'skuPicture', attrs: { label: 'sku图', noRequired: _this.skuPictureRule?.requireType != 1 }, input: { type: 'img', validator: (value, prop, sku) => validateSkuPicture(value, prop, _this, sku) }, unvisible: !_this.skuPictureRule?.support, slot: true, },
        { prop: 'price', attrs: { label: '价格' }, input: { type: 'number', validator: validateSkuPrice }, previewPrice: isShowPreviewPrice },
        { prop: 'skuSupplyPrice', attrs: { label: '供货价', noRequired: true }, unvisible: origin_form?.isDistribution == 0 },
        { prop: 'stockNum', attrs: { label: '现货库存' }, 
            input: { 
                type: 'number', 
                validator(value, prop) {
                    if (value === "" || value === undefined || value === null) {
                        return `商品明细中 ${prop.label || prop.name} 请勿输入空值`
                    } else if(value < 0) {
                        return `商品明细中 ${prop.label || prop.name} 不能小于0`
                    }
                    return false
                } 
            }, 
            disabledFn: (row) => row.stockType == 1 
        },
        { prop: 'outerSkuId', attrs: { label: 'sku编码', noRequired: true, width: 160, headerTooltip: '平台规格编码，对应平台sku外部商家编码，用于管理商品，并匹配ERP商品' }, input: { type: 'text' } },
        { prop: 'code', attrs: { label: '基础资料商家编码', width: 160, noRequired: _this.isGroupPuhuo, headerTooltip: _this.isGroupPuhuo ? '' : '必填，用于关联基础资料规格明细' }, input: { type: 'text', onlyTable: true } },     
        { prop: 'weight', attrs: { label: '重量（g）', noRequired: true, headerTooltip: '抖音小时达商品重量必填，默认单位g，支持最多输入三位小数' },  input: {  type: 'number', attrs: { precision: 3 } }, },
        { 
            prop: 'skuStatus', 
            attrs: { label: 'SKU售卖状态', noRequired: true, headerTooltip: 'SKU为“不可售”状态时，消费者在抖音不能选中此SKU进行购买' },
            input: {  type: 'number', onlyTable:true }, 
            slot: true,
        },
    ];
    return tableCols
}

